import React, { useEffect } from "react";

const Contact: React.FC = () => {
  useEffect(() => {
    document.body.className = "bg-dark";
    return () => {
      document.body.className = "";
    };
  }, []);
  return (
    <main>
      <section
        className="breadcrumb-area d-flex align-items-center"
        style={{ backgroundImage: "url(/images/bg-img/bdrc-bg.jpg)" }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12">
              <div className="breadcrumb-wrap text-center">
                <div className="breadcrumb-title">
                  <h2>Contact Us</h2>
                  <div className="breadcrumb-wrap">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <a href="/">Home</a>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                        >
                          Contact Us
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        id="contact"
        className="contact-area after-none contact-bg pt-50 pb-50 p-relative fix"
      >
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-6 order-1">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15062.778776315803!2d72.8750765!3d19.2956387!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b1791a9ba23b%3A0xb4712837df0bda6d!2sBangtan%20lounge!5e0!3m2!1sen!2sin!4v1678266936494!5m2!1sen!2sin"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <div className="col-lg-6 order-1">
              <div className="contact-info">
                <div
                  className="single-cta pb-30 mb-30 wow fadeInUp animated"
                  data-animation="fadeInDown animated"
                  data-delay=".2s"
                >
                  <div className="f-cta-icon">
                    <i className="far fa-map"></i>
                  </div>
                  <h5>Address</h5>
                  <p>
                    Ostwal Point Building, A Wing 1 / 101, Laxmi Park Circle,
                    beverly Park road, <br /> Unique Gardens, Next to BTS Cafe,
                    Mira Road East, Thane - 401107.
                  </p>
                </div>
                <div
                  className="single-cta pb-30 mb-30 wow fadeInUp animated"
                  data-animation="fadeInDown animated"
                  data-delay=".2s"
                >
                  <div className="f-cta-icon">
                    <i className="far fa-clock"></i>
                  </div>
                  <h5>Call Us</h5>
                  <p>+91 9619575411 / +91 9167903060 / +91 9987650780</p>
                </div>
                <div
                  className="single-cta wow fadeInUp animated"
                  data-animation="fadeInDown animated"
                  data-delay=".2s"
                >
                  <div className="f-cta-icon">
                    <i className="far fa-envelope-open"></i>
                  </div>
                  <h5>Message Us</h5>
                  <p>
                    <a href="/enquiry">
                      bangtanloungebiz@gmail.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
